import { EntityList, renderYesNothingIcon } from 'components/EntityList'
import { ConstrainMode, SelectionMode } from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { participantDetails } from 'views/ArchiveViews'
import {
  createFieldColumn,
  FieldColumn,
  getPersonDisplayName,
} from 'views/helpers'
import { ParticipantListProps } from 'views/Participants/ParticipantsByEndDate/ParticipantListByEndDate'

const qColumnProps: Partial<FieldColumn> = {
  minWidth: 50,
  maxWidth: 50,
  onRender: renderYesNothingIcon,
  ungroupable: true,
}
const qLargeColumnProps = {
  ...qColumnProps,
  maxWidth: 80,
}

export const PersonsByDepartmentList: React.FC<ParticipantListProps> = ({
  items,
  ...props
}) => {
  const newItems = Array.from(new Set(items.map((i) => i._id))).map((id) => {
    return items.find((i) => i._id === id)
  })

  const { t } = useTranslation()
  const fieldColumn = React.useMemo(() => createFieldColumn(t), [t])
  const columns = React.useMemo(
    () => [
      fieldColumn('name', {
        isGrouped: false,
        getGroupValue: (item: participantDetails) =>
          item.unknownPerson
            ? item.unknownPerson.department || ''
            : item.person!.lastName + ' . ' + item.person!.firstName,
        minWidth: 155,
        ungroupable: true,
      }),
      fieldColumn('type', {
        minWidth: 120,
        getGroupValue: (item: any) => getPersonDisplayName(item, t),
        onRender: (item: any, i, col) => getPersonDisplayName(item, t),
        useFullFieldname: true,
      }),
      fieldColumn('department', { ungroupable: true, isGrouped: true }),
      fieldColumn('companyName'),
      fieldColumn('qBasic', qColumnProps),
      fieldColumn('qTurbo', qColumnProps),
      fieldColumn('qSupersport', qLargeColumnProps),
      fieldColumn('qNordschleife', qLargeColumnProps),
      fieldColumn('qMuLow', qColumnProps),
      fieldColumn('qOffroad', qColumnProps),
      fieldColumn('employeeId'),
    ],
    [fieldColumn, t]
  )

  return (
    <EntityList
      alternate={true}
      stickyHeader={true}
      selectionMode={SelectionMode.single}
      items={newItems as any}
      constrainMode={ConstrainMode.horizontalConstrained}
      columns={columns}
      {...props}
    />
  )
}
